import styled from "@emotion/styled"
import { css, keyframes } from '@emotion/react'
import { fontSizes, space } from "gatsby-theme-photography-portfolio/src/utils/styles" //"../../utils/styles"



export const Holder = styled.div`
padding-bottom:1rem;
`

export const Wrapper = styled.div`
padding-top:1rem;
padding-bottom:1rem;
padding-left:1rem
`

export const Title = styled.div`
font-size:18px;
/* border-bottom: 1px solid; */
margin-bottom:1rem;
font-weight:700;
`

const hoverAnimLabel = keyframes`
from {
  width: 400px;
}
to {
  width: 140px;
}
 `

export const Label = styled.div`
font-size:0.8rem;
font-weight:400;
text-transform:uppercase;
display:flex;
cursor:pointer;
*{
  pointer-events:none;
}
:hover{
  background: var(--color-primary);
  animation-name: ${hoverAnimLabel};
  animation-duration: 1s;
  
  
}
span{

}
button {
  padding:1px;
  background:transparent;
  border:0;
  display:flex;
  align-items: center;
  justify-content: center;
}
`

export const ReadMore = styled.div`
font-size:12px;
font-weight:500;
border:1px solid;
display:inline-block;
padding: 2px 4px;
margin-left: 12px;
margin-top: 4px;
`

export const List = styled.ul`
  margin-left:0;
  display: ${props => props.expanded === false ? 'none' : 'block'};
`

export const ListItem = styled.li`
display:flex;
flex-direction:row;
margin-bottom: 0.5rem;
font-size: 0.9rem;

line-height: 1.1rem;

.node{
  color: var(--color-text);
  text-decoration: none;
  display: flex;
  flex-direction: column;
  
  span:first-of-type{
    font-weight:600;
  }
  
}
&.publications{ 
  .node{
    display: flex;
    flex-direction: column;
    font-weight:400;
    span:first-of-type{
      font-weight:400;
    }
    span:last-child{
      font-size: 0.9rem;
      font-weight:600;
    }
  }
}

> div {
  display:flex;
  flex-direction:column;
}
.location {
  font-size:0.8rem;
  font-weight:400;
}
::marker {
  content: '';
  font-size: 0.5em;
 
}

.icon {
  display:none;
}
`

export const InfoWrapper = styled.div`
padding-left:1rem;
padding-right:1rem;
`

/* display: ${props => props.visible === false ? 'none' : 'block'}; */
export const DescriptionWrapper = styled.div`
font-size:13px;
margin-left: 0;
margin-right: 1rem;
display: ${props => props.expanded === false ? 'none' : 'block'};
p {
  margin-bottom:0;
  margin-left: 0;
  text-align:justify;
}
`


/* padding-left: ${props => props.sideBar === false ? '74px' : '10px'} */


/*
export const Content = styled.div`
  width: 300px;
`

export const Title = styled.h1`
  color: white;
  margin-top: ${space[16]};
`

export const Subtitle = styled.h2`
  color: white;
`

export const Categories = styled.ul`
  list-style: none;
  padding-left: 0;

  li {
    color: white;
    text-decoration: none;
    font-size: ${fontSizes.lg};
  }
` */
